export default "__VITE_ASSET__BZUUQrIv__"